// import {
//   FileText,
//   ScrollText,
//   BookMarked,
//   Timer,
//   BadgeCheck,
//   Handshake
// } from "lucide-react";

// const AIDrafting = () => {
//   const content = [
//     {
//       text: "Jurident's advanced AI Drafting feature streamlines the complex process of legal document creation by generating meticulously structured, professional-grade drafts within seconds.",
//       icon: FileText,
//     },
//     {
//       text: "Whether you need contracts, petitions, affidavits, or legal notices, our intelligent system is engineered to comprehend the nuances of legal language and context, ensuring that each document aligns with jurisdictional standards and client-specific requirements.",
//       icon: ScrollText,
//     },
//     {
//       text: "By leveraging state-of-the-art natural language processing and legal domain expertise, Jurident empowers legal professionals to produce high-quality, review-ready documents with unparalleled speed and precision.",
//       icon: BookMarked,
//     },
//     {
//       text: "This not only reduces the risk of human error but also significantly cuts down the time spent on repetitive drafting tasks, allowing practitioners to allocate more time to critical legal analysis and strategic decision-making.",
//       icon: Timer,
//     },
//     {
//       text: "With Jurident, legal teams can enhance their operational efficiency, maintain compliance, and deliver consistent, accurate documentation—every time.",
//       icon: BadgeCheck,
//     },
//     {
//       text: "Let our AI handle the paperwork, while you focus on what truly matters: providing exceptional legal counsel.",
//       icon: Handshake,
//     },
//   ];

//   return (
//     <div className="relative w-full min-h-screen bg-white flex justify-center items-center overflow-hidden soft-bg">
//       {/* White background */}
//       <div className="absolute inset-0 bg-white -z-20"></div>

//       {/* Background image */}
//       <img
//         src="image 3.png"
//         alt="Background"
//         className="absolute w-[90%] top-[55%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10 z-0 sm:opacity-60 sm:w-[70%]"
//       />

//       {/* Content Container */}
//       <div className="z-10 w-[90%] sm:w-[75%] mt-[100px] sm:mt-[150px] pb-10 px-4 sm:px-8 flex flex-col sm:justify-start text-left glass-card-mobile">

//         {/* Heading */}
//         <h1 className="text-[20px] sm:text-[32px] font-extrabold font-['Arial'] text-[#bfa87c] mb-6 sm:mb-10 tracking-wide">
//           AI Drafting
//         </h1>

//         {/* Content Paragraphs */}
//         {content.map(({ text, icon: Icon }, index) => (
//           <p
//             key={index}
//             className="text-[14px] sm:text-[18px] font-[500] font-['Arial'] text-[#4a4a4a] leading-relaxed tracking-normal mb-8 sm:mb-[22px] flex items-start gap-3 desktop-tight-spacing"
//           >
//             <span className="sm:hidden block mt-[3px]">
//               <Icon className="w-4 h-4 text-[#bfa87c]" />
//             </span>
//             {text}
//           </p>
//         ))}

//         {/* Coming Soon Button */}
//         <div className="mt-4 sm:mt-8 flex justify-start desktop-tight-spacing">
//           <button className="coming-soon-btn text-sm sm:text-lg font-semibold text-white px-5 py-2 sm:px-8 sm:py-3 rounded-full bg-[#bfa87c] shadow-md font-['Arial'] transition-all duration-300 cursor-pointer">
//             Coming Soon
//           </button>
//         </div>
//       </div>

//       {/* CSS styles */}
//       <style>{`
//         @keyframes glowFadeGold {
//           0%, 100% {
//             box-shadow: 0 0 10px rgba(191, 168, 124, 0.6), 0 0 20px rgba(191, 168, 124, 0.4);
//           }
//           50% {
//             box-shadow: 0 0 20px rgba(191, 168, 124, 0.9), 0 0 40px rgba(191, 168, 124, 0.7);
//           }
//         }

//         @media (max-width: 640px) {
//           .coming-soon-btn {
//             animation: glowFadeGold 2.5s ease-in-out infinite;
//           }
//           .glass-card-mobile {
//             background: rgba(255, 255, 255, 0.07);
//             backdrop-filter: blur(8px);
//             -webkit-backdrop-filter: blur(8px);
//             border-radius: 16px;
//             border: 1px solid rgba(43, 12, 12, 0.07);
//             box-shadow: 0 8px 32px rgba(0, 0, 0, 0.14);
//             padding: 20px;
//             margin-bottom: 20px;
//           }
//         }

//         @media (min-width: 641px) {
//           .soft-bg {
//             height: 100vh;
//             overflow: hidden;
//           }
//           .coming-soon-btn:hover {
//             box-shadow: 
//               0 0 30px rgba(191, 168, 124, 0.8),
//               0 0 60px rgba(191, 168, 124, 0.6),
//               0 10px 40px rgba(0, 0, 0, 0.2);
//             transform: scale(1.05);
//           }

//           /* Desktop tight spacing override */
//           .desktop-tight-spacing {
//             margin-bottom: 12px !important;
//           }
//           h1 {
//             margin-bottom: 20px !important;
//           }
//         }

//         .soft-bg {
//           background-color: #ffffff;
//           background-image:
//             radial-gradient(circle, rgba(191, 168, 124, 0.05) 1px, transparent 1px),
//             linear-gradient(45deg, rgba(191, 168, 124, 0.02) 25%, transparent 25%),
//             linear-gradient(-45deg, rgba(191, 168, 124, 0.02) 25%, transparent 25%);
//           background-size: 3px 3px, 30px 30px, 30px 30px;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default AIDrafting;





















// import {
//   FileText,
//   ScrollText,
//   BookMarked,
//   Timer,
//   BadgeCheck,
//   Handshake
// } from "lucide-react";

// const AIDrafting = () => {
//   const content = [
//     {
//       text: "Jurident's advanced AI Drafting feature streamlines the complex process of legal document creation by generating meticulously structured, professional-grade drafts within seconds.",
//       icon: FileText,
//     },
//     {
//       text: "Whether you need contracts, petitions, affidavits, or legal notices, our intelligent system is engineered to comprehend the nuances of legal language and context, ensuring that each document aligns with jurisdictional standards and client-specific requirements.",
//       icon: ScrollText,
//     },
//     {
//       text: "By leveraging state-of-the-art natural language processing and legal domain expertise, Jurident empowers legal professionals to produce high-quality, review-ready documents with unparalleled speed and precision.",
//       icon: BookMarked,
//     },
//     {
//       text: "This not only reduces the risk of human error but also significantly cuts down the time spent on repetitive drafting tasks, allowing practitioners to allocate more time to critical legal analysis and strategic decision-making.",
//       icon: Timer,
//     },
//     {
//       text: "With Jurident, legal teams can enhance their operational efficiency, maintain compliance, and deliver consistent, accurate documentation—every time.",
//       icon: BadgeCheck,
//     },
//     {
//       text: "Let our AI handle the paperwork, while you focus on what truly matters: providing exceptional legal counsel.",
//       icon: Handshake,
//     },
//   ];

//   return (
//     <div className="relative w-full min-h-screen bg-white flex justify-center overflow-hidden soft-bg">

//       {/* Background image */}
//       <img
//         src="image 3.png"
//         alt="Background"
//         className="absolute w-[90%] top-[55%] left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-10 sm:opacity-60 sm:w-[70%]"
//       />

//       {/* Content */}
//     <div className="relative z-10 w-[90%] sm:w-[75%] pt-32 sm:pt-[150px] pb-16 px-4 sm:px-8">

//         {/* Heading */}
//         <h1 className="text-[22px] sm:text-[36px] font-extrabold text-[#bfa87c] mb-10 tracking-wide">
//           AI Drafting
//         </h1>

//         {/* Feature Blocks */}
//         <div className="space-y-6 sm:space-y-5">
//           {content.map(({ text, icon: Icon }, index) => (
//             <div
//               key={index}
//               className="flex gap-4 items-start p-4 sm:p-5 rounded-2xl
//               bg-white/60 backdrop-blur-md
//               border border-[#bfa87c]/10
//               shadow-[0_8px_30px_rgba(0,0,0,0.08)]
//               transition-all duration-300
//               hover:-translate-y-[2px] hover:shadow-[0_12px_40px_rgba(0,0,0,0.12)]"
//             >
//               {/* Icon */}
//               <div className="mt-[2px] flex-shrink-0">
//                 <div className="w-9 h-9 rounded-full bg-[#bfa87c]/15 flex items-center justify-center">
//                   <Icon className="w-4 h-4 text-[#bfa87c]" />
//                 </div>
//               </div>

//               {/* Text */}
//               <p className="text-[14px] sm:text-[18px] font-medium text-[#4a4a4a] leading-relaxed">
//                 {text}
//               </p>
//             </div>
//           ))}
//         </div>

//        {/* Text CTA */}
// <div className="mt-16 flex justify-center">
//   <a
//     href="https://www.jurident.com/portal"
//     target="_blank"
//     rel="noopener noreferrer"
//     className="group relative text-[22px] sm:text-[34px] font-bold text-[#bfa87c] tracking-wide cursor-pointer text-center hover:tracking-wider transition-all duration-300"
//   >
//     Explore in Jurident Portal

//     {/* Arrow animation */}
//     <span className="ml-3 inline-block transition-transform duration-300 group-hover:translate-x-2">
//       →
//     </span>

//     {/* Underline animation */}
//     <span className="absolute left-1/2 -translate-x-1/2 -bottom-2 w-0 h-[3px] bg-[#bfa87c] transition-all duration-300 group-hover:w-[60%]"></span>
//   </a>
// </div>
      
//       </div>

//       {/* Styles */}
//       <style>{`
//         @keyframes glowFadeGold {
//           0%, 100% {
//             box-shadow: 0 0 10px rgba(191,168,124,.5);
//           }
//           50% {
//             box-shadow: 0 0 25px rgba(191,168,124,.9);
//           }
//         }

//         .coming-soon-btn:hover {
//           transform: translateY(-2px) scale(1.05);
//           box-shadow: 0 15px 40px rgba(191,168,124,.5);
//         }

//         @media (max-width: 640px) {
//           .coming-soon-btn {
//             animation: glowFadeGold 2.5s ease-in-out infinite;
//           }
//         }

//         .soft-bg {
//           background-color: #ffffff;
//           background-image:
//             radial-gradient(circle, rgba(191,168,124,0.05) 1px, transparent 1px),
//             linear-gradient(45deg, rgba(191,168,124,0.02) 25%, transparent 25%),
//             linear-gradient(-45deg, rgba(191,168,124,0.02) 25%, transparent 25%);
//           background-size: 3px 3px, 30px 30px, 30px 30px;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default AIDrafting;





















import {
  FileText,
  ScrollText,
  BookMarked,
  Timer,
  BadgeCheck,
  Handshake
} from "lucide-react";

const AIDrafting = () => {
  const content = [
  {
    text: "Jurident’s advanced AI chatbot transforms how legal professionals and clients interact with complex legal information, delivering intelligent summarization, drafting assistance, and contextual legal insights in one intuitive interface.",
    icon: FileText,
  },
  {
    text: "Reduce document review time by up to 70–80% with instant summaries of legal notices, draft petitions, and structured case briefs. Critical facts, issues, and arguments are extracted within seconds.",
    icon: ScrollText,
  },
  {
    text: "Strengthen legal strategy with relevant precedents from High Courts and the Supreme Court, improving research efficiency by nearly 60% and enabling smarter, precedent-backed decisions.",
    icon: BookMarked,
  },
  {
    text: "For clients, complex legal notices are simplified into clear, easy-to-understand language, improving comprehension by over 75% and ensuring better awareness of legal positions and next steps.",
    icon: Timer,
  },
  {
    text: "Supports bulk processing upload 10+ notices and receive summaries, key issue identification, and insights in under 30 seconds, saving 5–10 hours per week.",
    icon: BadgeCheck,
  },
  {
    text: "Minimize drafting and review errors by up to 50% while enabling teams to handle 2–3× more cases, boosting productivity, turnaround time, and client satisfaction.",
    icon: Handshake,
  },
];

  return (
    <div className="relative w-full min-h-screen bg-white flex justify-center overflow-hidden soft-bg">

      {/* Background image */}
      <img
        src="image 3.png"
        alt="Background"
        className="absolute w-[90%] top-[55%] left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-10 sm:opacity-60 sm:w-[70%]"
      />

      {/* Content */}
      <div className="relative z-10 w-[90%] sm:w-[75%] pt-32 sm:pt-[150px] pb-16 px-4 sm:px-8">

        {/* Heading */}
        <h1 className="text-[22px] sm:text-[36px] font-extrabold text-[#bfa87c] mb-10 tracking-wide">
          AI JURICHAT
        </h1>

        {/* Feature Blocks */}
        <div className="space-y-6 sm:space-y-5">
          {content.map(({ text, icon: Icon }, index) => (
            <div
              key={index}
              className="flex gap-4 items-start p-4 sm:p-5 rounded-2xl
              bg-white/60 backdrop-blur-md
              border border-[#bfa87c]/10
              shadow-[0_8px_30px_rgba(0,0,0,0.08)]
              transition-all duration-300
              hover:-translate-y-[2px] hover:shadow-[0_12px_40px_rgba(0,0,0,0.12)]"
            >
              {/* Icon */}
              <div className="mt-[2px] flex-shrink-0">
                <div className="w-9 h-9 rounded-full bg-[#bfa87c]/15 flex items-center justify-center">
                  <Icon className="w-4 h-4 text-[#bfa87c]" />
                </div>
              </div>

              {/* Text */}
              <p className="text-[14px] sm:text-[18px] font-medium text-[#4a4a4a] leading-relaxed">
                {text}
              </p>
            </div>
          ))}
        </div>

        {/* KEY BENEFITS */}
        <div className="mt-14 grid sm:grid-cols-2 gap-6">

          <div className="p-6 rounded-2xl bg-white/60 backdrop-blur-md border border-[#bfa87c]/10 shadow">
            <h3 className="text-[#bfa87c] font-semibold mb-2 text-[18px] sm:text-[22px]">
  For Lawyers
</h3>
            <p className="text-[#4a4a4a] text-[14px] sm:text-[17px]">
  Faster research, prior judgments from the Supreme Court and High Courts, drafting documents, stronger case preparation, reduced workload, and increased case-handling capacity.
</p>
          </div>

          <div className="p-6 rounded-2xl bg-white/60 backdrop-blur-md border border-[#bfa87c]/10 shadow">
            <h3 className="text-[#bfa87c] font-semibold mb-2 text-[18px] sm:text-[22px]">
  For Clients
</h3>

<p className="text-[#4a4a4a] text-[14px] sm:text-[17px]">
  Get summaries of notices, case-related queries, case references, legal guidance, and improved trust and clarity.
</p>
          </div>

        </div>

        {/* Text CTA */}
        <div className="mt-16 flex justify-center">
          <a
            href="https://www.jurident.com/portal"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative text-[22px] sm:text-[34px] font-bold text-[#bfa87c] tracking-wide cursor-pointer text-center hover:tracking-wider transition-all duration-300"
          >
            Explore in Jurident Portal

            {/* Arrow animation */}
            <span className="ml-3 inline-block transition-transform duration-300 group-hover:translate-x-2">
              →
            </span>

            {/* Underline animation */}
            <span className="absolute left-1/2 -translate-x-1/2 -bottom-2 w-0 h-[3px] bg-[#bfa87c] transition-all duration-300 group-hover:w-[60%]"></span>
          </a>
        </div>

      </div>

      {/* Styles */}
      <style>{`
        @keyframes glowFadeGold {
          0%, 100% {
            box-shadow: 0 0 10px rgba(191,168,124,.5);
          }
          50% {
            box-shadow: 0 0 25px rgba(191,168,124,.9);
          }
        }

        .coming-soon-btn:hover {
          transform: translateY(-2px) scale(1.05);
          box-shadow: 0 15px 40px rgba(191,168,124,.5);
        }

        @media (max-width: 640px) {
          .coming-soon-tag {
            animation: glowFadeGold 2.5s ease-in-out infinite;
          }
        }

        .soft-bg {
          background-color: #ffffff;
          background-image:
            radial-gradient(circle, rgba(191,168,124,0.05) 1px, transparent 1px),
            linear-gradient(45deg, rgba(191,168,124,0.02) 25%, transparent 25%),
            linear-gradient(-45deg, rgba(191,168,124,0.02) 25%, transparent 25%);
          background-size: 3px 3px, 30px 30px, 30px 30px;
        }
      `}</style>
    </div>
  );
};

export default AIDrafting;
